// extracted by mini-css-extract-plugin
export default {"root":"SkipLinks-root_SMIH7","wrapper":"SkipLinks-wrapper_TemeI","link":"SkipLinks-link_GN8Nj"};